// extracted by mini-css-extract-plugin
export default {"popup":"invitation-popup__popup___hEMZn","popupBody":"invitation-popup__popupBody___ObEcX"};